import { Icon } from '../../../ui/Icon.js';
import { useI18n } from '../../../i18n/i18n.js';
import { useVrStore } from './vrSupport.js';

/** Project list in a headset: open a project to explore it in VR. */
export function VrProjectsHint() {
  const supported = useVrStore((s) => s.supported);
  const headset = useVrStore((s) => s.headset);
  const t = useI18n().m.editor.vr;
  if (!supported || !headset) return null;
  return (
    <p className="vr-projects-hint" role="status" data-testid="vr-projects-hint">
      <Icon name="vr" />
      <span>
        <strong>{t.suggestTitle}</strong> {t.projectsHint}
      </span>
    </p>
  );
}
